import { http, useAPI } from '~~core';

import { BrandFetchResponseSchema } from '../schemas';

export async function fetchBrand(signatureRequestKey: string) {
  const { getEndpoint } = useAPI(signatureRequestKey);
  const data = await http(getEndpoint('brand'), {
    method: 'get',
  });

  return BrandFetchResponseSchema.parse(data).brand;
}
